import { Component, OnDestroy, OnInit, NgZone } from '@angular/core';
import { APIService } from '../../../api/api.service';
import { NotifierService } from '../../../_services/notifier.service';

import * as moment from 'moment';

declare let flatpickr: any;
declare let window: any;
declare let $: any;
@Component({
  templateUrl: './rdsri.component.html',
})
export class RDSRIComponent implements OnInit, OnDestroy {
  userId = localStorage.getItem('eId');
  ut = localStorage.getItem('ut');
  urlPrefix: any = localStorage.getItem('role') == 'Admin' ? 'admin' : 'client';
  writeAccess: boolean =
    localStorage.getItem('acT') == 'readandwrite' ||
    this.urlPrefix == 'admin' ||
    localStorage.getItem('ut') == 'admin';
  loading = true;
  riData: any = [];
  updateRI: any;
  updateAction: any = 'update';
  masterAccounts: any = [];
  fetchAccountID: string;


  accountId: any;
  regionId: any;
  currentMessage: any;
  unsavedRI: any = [];

  headers: any = [
    {
      id: 'accId',
      name: 'Master Account',
    },
    {
      id: 'accountName',
      name: 'Client Name',
    },
    {
      id: 'riApplied',
      name: 'RI Applied',
    },
    {
      id: 'riType',
      name: 'RI Type',
    },

  ];

  funRef: any = {};
  deleteRI: any;
  unsavedUpdateId: number = -1;

  constructor(
    private notifier: NotifierService,
    private apiService: APIService
  ) {}

  ngOnInit(): void {
    this.accountId = localStorage.getItem('accountId');
    this.regionId = localStorage.getItem('regionId');
    this.funRef = {};

    this.currentMessage = this.notifier.currentMessage.subscribe((msg) => {
      let d = JSON.parse(msg);
      if (d.value == null) {
        return;
      }
      if (d.key == 'accountId') {
        this.accountId = d.value;
        this.load();
      } else if (d.key == 'regionId') {
        this.regionId = d.value;
        this.load();
      }
    });
  }

  // async loadMasterAccounts() {
  //   if (
  //     this.masterAccounts.length > 0 &&
  //     this.fetchAccountID == this.accountId
  //   ) {
  //     await this.fetchdetails($('#masterAccountSelect').val());
  //     return;
  //   }
  //   this.fetchAccountID = this.accountId;
  //   let data = {
  //     action: 'fetchMasterAccountList',
  //   };

  //   let header = {
  //     Authorization: localStorage.getItem('t'),
  //   };
  //   let apiURL = `https://api.swayam.cloud/prod/msopsusers/billing/fetchmasteraccountlist`;

  //   let result = await this.apiService.postDataPromis(apiURL, data, header);

  //   console.log("result", result);
  //   if (result.status == '1' || result.s == '1') {
  //     this.masterAccounts = result.masterAccountIDList;
  //     if (this.masterAccounts && this.masterAccounts.length > 0) {
  //       setTimeout(async () => {
  //         $('#masterAccountSelect').selectpicker('refresh');
  //         $('#masterAccountSelect').val(this.masterAccounts[0]);
  //         $('#masterAccountSelect').selectpicker('refresh');
  //         await this.fetchdetails(this.masterAccounts[0]);
  //       }, 100);
  //     } else {
  //       setTimeout(async () => {
  //         $('#masterAccountSelect').val('');
  //         $('#masterAccountSelect').selectpicker('refresh');
  //       }, 100);
  //       this.masterAccounts = [];
  //     }
  //   } else {
  //     this.notifier.alert('Info', '', result.msg, 'info', 5000);
  //   }
  // }
  async load() {
    this.notifier.loading(true);
    await this.fetchdetails(this.accountId);
    this.notifier.loading(false);
  }
  

  async fetchdetails(accountId: string) {
    this.notifier.loading(true);

    let data = { action: 'fetchall' };
    let header = {
      Authorization: localStorage.getItem('t'),
    };
    let apiURL = `https://api.swayam.cloud/v3/admin/billing/master-ri-details`;
    let result = await this.apiService.postDataPromis(apiURL, data, header);
    console.log("result",result);

    if (result.status == '1' || result.s == '1') {
      this.riData = result.data;
    } else {
      this.riData = [];
      this.notifier.alert('Info', '', result.msg, 'info', 5000);
    }
    this.notifier.loading(false);
  }

  updateTrigger(id: any) {
    this.updateAction = 'update';
    this.updateRI = id;
    this.updateRI.type = 'edit'
    console.log('details', this.updateRI);
  }

  deleteUnsavedRI(id: number) {
    this.unsavedRI.splice(id, 1);
  }

  updateUnsavedRI(id: any, index: number) {
    this.updateAction = 'save';
    this.unsavedUpdateId = index;
    this.updateRI = id;
  }

  closeUpdateTrigger(event: any) {
    if (event) {
      // if (this.updateAction == 'update') {
        this.load();
      // } else {
      //   event.riDetailsList[0]['riCost'] =
      //     event.riDetailsList[0]['riCost'] == 'NA'
      //       ? 0.0
      //       : event.riDetailsList[0]['riCost'];
      //   if (this.unsavedUpdateId > -1) {
      //     this.unsavedRI[this.unsavedUpdateId] = event.riDetailsList[0];
      //     this.unsavedUpdateId = -1;
      //   } else {
      //     this.unsavedRI.push(event.riDetailsList[0]);
      //   }
      // }
    }

    this.updateRI = null;
  }

  async deleteTrigger(id: any) {
    this.notifier.loading(true);
    let data: any = {
      accountId: this.accountId,
      action: 'delete',
      id: id.id,
    };

    let header = {
      Authorization: localStorage.getItem('t'),
    };
    let apiURL = `https://api.swayam.cloud/prod/msopsusers/billing/fetchrdsripurchaseorder`;
    let result = await this.apiService.postDataPromis(apiURL, data, header);
    if (result.status == '1' || result.s == '1') {
      this.notifier.alert('Success', '', result.msg, 'success', 5000);
      this.load();
    } else {
      this.notifier.alert('Info', '', result.msg, 'info', 5000);
    }

    this.notifier.loading(false);
  }

  closeDeleteTrigger(event: any) {
    this.deleteRI = null;
  }

  addPurchase() {
    this.updateAction = 'save';
    this.unsavedUpdateId = -1;
    console.log("addpurchase in ri", this.updateRI);
    this.updateRI = {
      accId: "",
            riApplied: "",
            riType: "",
            type: "add"

    };
  }

  async saveDetails() {
    this.notifier.loading(true);
    let data: any = {
      accountId: this.accountId,
      action: 'save',
      riDetailsList: this.unsavedRI.map((ri: any) => {
        Object.keys(ri).forEach((ri_: any) => {
          ri[ri_] = ri[ri_] || 'NA';
        });
        delete ri.id;
        ri.quantity = `${ri.quantity}`;
        return ri;
      }),
    };

    let header = {
      Authorization: localStorage.getItem('t'),
    };

    let apiURL: string =
      'https://api.swayam.cloud/prod/msopsusers/billing/fetchrdsripurchaseorder';

    let result = await this.apiService.postDataPromis(apiURL, data, header);

    if (result.status == '1' || result.s == '1') {
      this.notifier.alert('Success', '', result.msg, 'success', 5000);
      this.unsavedRI = [];
      this.load();
    } else {
      this.notifier.alert('Info', '', result.msg, 'info', 5000);
    }
    this.notifier.loading(false);
  }

  callFunction(param: any, id: any) {
    this.funRef[param](this, id);
  }

  ngOnDestroy(): void {
    this.currentMessage.unsubscribe();
  }
}
